import ApplicationAdapter from './application';

export default class NotificationConfigurationAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'notification-configurations';
  }
}
